import { render, staticRenderFns } from "./V6SlideCharacter.vue?vue&type=template&id=e0136b48&scoped=true&"
import script from "./V6SlideCharacter.vue?vue&type=script&lang=js&"
export * from "./V6SlideCharacter.vue?vue&type=script&lang=js&"
import style0 from "./V6SlideCharacter.vue?vue&type=style&index=0&id=e0136b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0136b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
